import { getAccountFileDownloadRanking } from 'api';
import Pagination from 'components/Pagination';
import { defaultPageSizeOptions } from 'constant/Pagination/pageSizeOption';
import useErrorNetworkMessage from 'hook/useErrorNetworkMessage';
import useCustomQuery from 'hook/useQuery/useCustomQuery';
import { useEffect, useState } from 'react';
import FileDownloadRankingTable from './FileDownloadRankingTable';
import { TableStyle } from './LayoutDefault/styled';

const FileDownloadRanking = ({
  filterData,
  pageSize,
  countToReset,
  setIsFilesDownloadTableLoading,
  emptyText,
}) => {
  const { useQueryAPI } = useCustomQuery();
  const { isOnline, errorNetWork } = useErrorNetworkMessage();

  const [pageNumber, setPageNumber] = useState(1);

  const { data: fileDownloadRankingList = [], isLoading } = useQueryAPI({
    api: getAccountFileDownloadRanking,
    key: 'getAccountFileDownloadRankingList',
    params: {
      pageNumber,
      pageSize,
      dateFrom: filterData.dateFrom.format('YYYY-MM-DD'),
      dateTo: filterData.dateTo.format('YYYY-MM-DD'),
      keyword: filterData?.email,
    },
    enabled: filterData?.email !== null && filterData?.email !== undefined,
  });

  useEffect(() => {
    setPageNumber(1);
  }, [countToReset, pageSize]);

  useEffect(() => {
    setIsFilesDownloadTableLoading(isLoading);
  }, [isLoading]);

  const handleChangePageNumber = (pageNumber) => {
    if (isOnline) {
      setPageNumber(pageNumber);
    } else {
      errorNetWork();
    }
  };

  return (
    <TableStyle>
      <FileDownloadRankingTable
        dataRaw={fileDownloadRankingList?.data}
        isLoading={isLoading}
        emptyText={isLoading ? '集計中です。' : emptyText}
      />

      <Pagination
        currentPage={pageNumber}
        handlePagingChange={handleChangePageNumber}
        total={fileDownloadRankingList?.data?.total}
        pageSize={pageSize}
        pageSizeOptions={defaultPageSizeOptions}
        isShowTotal={false}
      />
    </TableStyle>
  );
};

export default FileDownloadRanking;
